<template>
  <div>
    <!-- :get-form-data="fromData" -->
    <list
      row-key="UserId"
      ref="list"
      unit="组合BOM管理"
      show-query
      :page="true"
      :get-data-func="api.list"
      :query-params="params"  
      @row-select="rowSelect"
    >
      <template slot="toolbar-right">
        <slot name="toolbar-right"></slot>
        <el-button type="primary" @click="onExport" >导出</el-button>
      </template>
       <template slot="query">
        <el-form-item label="存货名称">
          <el-input size="mini" clearable v-model="params.ProductName" placeholder="请输入存货名称" />
        </el-form-item>
        <el-form-item label="Bom">
          <el-input size="mini" clearable v-model="params.BomNo" placeholder="请输入bom" />
        </el-form-item>
        <el-form-item label="是否停用">
          <el-select v-model="params.Disabled" placeholder="请选择">
            <el-option
              v-for="item in [{value: 1, label: '是'}, {value: 0, label: '否'}]"
              :key="item.value"
              :label="item.label"
              :value="item.value">
            </el-option>
          </el-select>
          <!-- <el-checkbox  v-model="isEnable" @change="changeIsEnable"></el-checkbox> -->
        </el-form-item>
      </template>
      <template slot="table">
        <el-table-column prop="ProductName" label="存货名称" min-width="100" align="left"></el-table-column>
        <el-table-column prop="ProductSpec" label="规格" min-width="100" align="left"></el-table-column>
        <el-table-column prop="PdUnitName" label="单位" min-width="100" align="left"></el-table-column>
        <el-table-column prop="ColorName" label="颜色" min-width="100" align="left"></el-table-column>
        <el-table-column prop="Quantity" label="需求数量" min-width="100" align="right"></el-table-column>
        <el-table-column prop="ImgUrl" label="图片" min-width="100" align="center">
           <template  slot-scope="{ row }">
                <el-button  type="text" @click="viewImg1(row)">{{ row.ProductId ? "查看" : "" }}</el-button>
            </template>
        </el-table-column>
        <el-table-column prop="ProcessStage" label="加工阶段" min-width="100" align="left">
          <template  slot-scope="{ row }">
                <span >{{
                    (() => {
                      if (row.ProcessStage === 4) {
                        return "组合";
                      } else if (row.ProcessStage === 3) {
                        return "装配";
                      } else if (row.ProcessStage === 2) {
                        return "配件";
                      } else if (row.ProcessStage === 1) {
                        return "注塑";
                      } else if (row.ProcessStage === 0) {
                        return "无";
                      }
                    })()
                  }}</span>
            </template>
          
        </el-table-column>
        <el-table-column prop="ProduceTypeName" label="存货类型" min-width="100" align="left"></el-table-column>
        <el-table-column prop="Bomno" label="版本号" min-width="100" align="left"></el-table-column>
        <el-table-column prop="IsDefault" label="默认Bom" min-width="100" align="center">
          <template slot-scope="{ row }">
            <span>{{ row.IsDefault?"是":"否" }}</span>
            </template>
          </el-table-column>
        <slot name="column"></slot>
      </template>
    </list>

    <el-table v-show="isShow" border class="table_bottom table-line tb-c-head" :data="tableData" style="margin-top: 18px;">
        <el-table-column prop="ProductNo" label="存货编码" min-width="100" align="center"></el-table-column>
        <el-table-column prop="ProductName" label="存货名称" min-width="100" align="center"></el-table-column>
        <el-table-column prop="ProductSpec" label="规格" min-width="100" align="center"></el-table-column>
        <el-table-column prop="PdUnitName" label="单位" min-width="100" align="center"></el-table-column>
        <el-table-column prop="PropertyName" label="属性" min-width="100" align="center"></el-table-column>
        <el-table-column prop="ColorName" label="颜色" min-width="100" align="center"></el-table-column>
        <el-table-column prop="Quantity" label="需求数量" min-width="100" align="center"></el-table-column>
        <el-table-column prop="ImgUrl" label="图片" min-width="100" align="center">
           <template  slot-scope="{ row }">
                <el-button  type="text" @click="viewImg1(row)">{{ row.ProductId ? "查看" : "" }}</el-button>
            </template>
        </el-table-column>
        <el-table-column prop="ProcessStage" label="加工阶段" min-width="100" align="center">
          <template  slot-scope="{ row }">
                <span >{{
                    (() => {
                      if (row.ProcessStage === 4) {
                        return "组合";
                      } else if (row.ProcessStage === 3) {
                        return "装配";
                      } else if (row.ProcessStage === 2) {
                        return "配件";
                      } else if (row.ProcessStage === 1) {
                        return "注塑";
                      } else if (row.ProcessStage === 0) {
                        return "无";
                      }
                    })()
                  }}</span>
            </template>
        </el-table-column>
        <el-table-column prop="ProduceTypeName" label="存货类型" min-width="100" align="center"></el-table-column>
    </el-table>
    <img-dialog ref="imgDialog" :imgs="imgs" />
  </div>
</template>
<script>


import listMixin from "@/mixins/list";
import imgDialog from "@/components/production/craftsmanship/bom/imgDialog";
import list from "@/components/common/list";
import { urlHttp } from '@/components/production/craftsmanship/bom/bomConfig'

export default {
  mixins: [listMixin],
  components: { list, imgDialog },
  data() {
    return {
      api: require("@/api/production/teProduct").default,
      pdApi: require("@/api/ba/product").default,
      params: {
        Stage: 4,
        ProductName: "",
        BomNo: "",
        Disabled: 0,
      },
      imgs: [],
      tableData: [],
      isEnable: false,
      isShow: false,
     
    };
  },
  methods: {
    onExport() {
      this.$confirm("是否导出数据？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          var list = this.$refs.list;
          var listParams = list.tempQueryParams;
          var fields = "ProductName,ProductSpec,PdUnitName,ColorName,Quantity,ProcessStage,ProduceTypeName,Bomno,IsDefault,Status";
          var params = { ...listParams, Fields: fields };
          // console.log('onExport', params);
          var loading = this.$loading({
            lock: true,
            text: "正在导出...",
            spinner: "el-icon-loading",
            customClass: "my_loading",
            background: "rgba(0, 0, 0, 0.3)",
          });
          this.api.combinationExport(params).then(res => {
            loading.close();
          })
        })
        .catch(err => {
          console.log(err);
        });
      
    },
    changeIsEnable(){
      this.params.IsEnable = !this.isEnable;
    },
    base64ToFile(dataurl, filename) {//将base64转换为文件
      var arr = dataurl.split(','), mime = arr[0].match(/:(.*?);/)[1],
          bstr = atob(arr[1]), n = bstr.length, u8arr = new Uint8Array(n);
      while(n--){
          u8arr[n] = bstr.charCodeAt(n);
      }
      return new File([u8arr], filename, {type:mime});
    },
    // async viewImg(row) {
    //   const res = await this.api.getNewInfo(TeProductId);
    //   let imgs = [];
    //   if(res.Code==0){
    //     imgs = res.Data.Imgs;
    //   }
    //   if (!imgs || imgs?.length < 1) return this.$message.warning('无图片！');
    //   imgs = imgs.map(item => {
    //     return URL.createObjectURL(this.base64ToFile(item.ImgUrl));
    //   })
    //   this.imgs = imgs;
    //   this.$refs.imgDialog.open();
    // },
    async viewImg1(row) {
      const res = await this.pdApi.productImgList(row.ProductId)
      if (res.Code != 0) return this.$message.warning(res.Msg);
      const ImgUrl = res.Data;
      if (!ImgUrl || ImgUrl?.length < 1) return this.$message.warning('无图片！');
      let imgs = [];
      ImgUrl.forEach(item => {
        // const imgBlob = URL.createObjectURL(this.base64ToFile(item.ImgUrl));
        // imgs.push(imgBlob);
        imgs.push('/api' + item.ImgUrl)
      })
      this.imgs = imgs;
      this.$refs.imgDialog.open();
    },
    // viewImg(ImgUrl) {
    //   let imgs = ImgUrl.split(",");
    //   imgs.forEach((item) => {
    //     item = urlHttp + item;
    //   });

    //   this.imgs = imgs;
    //   this.$refs.imgDialog.open();
    // },
    rowSelect(rows){  
      this.isShow = true;
      this.api.getNewInfo(rows.TeProductId).then((res) => {
        console.log(res,'res')
        if(res.Code==0){
          this.tableData = res.Data.DetailModels
          console.log(this.tableData,'this.table')
        //   res.Data.DetailModels.forEach(item=>{
        //   item.T=null
        //   let o = {
        //   ProgrammeName: item.ProgrammeName,
        //   ProcessSn: item.Sn == null ? item.ProcessSn : item.Sn,
        //   ...item,       
        //   Units: item.Units == null ? "" : item.Units,
        //   Colors: item.Colors == null ? "" : item.Colors,
        //  }
        //  arr.push(o);
        // })  
        }
      })
   
    },
    
  }
};
</script>
